import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {
  TextField
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { getIdArray } from 'helpers/dataHelpers'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Config from 'config'


const AreasOfLawInput = (props) => {
  const {
    error,
    helperText,
    setValue,
    defaultValue,
    className,
    InputLabelProps,
    placeholder,
    single
  } = props
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [areasOfLaw, setAreasOfLaw] = useState([])

  const getAreas = () => {
    const url = `${apiUrl}areas-of-law/`
    axios.get(url).then((body) => {
      const { data } = body
      setAreasOfLaw(data)
    }).catch(error => {
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  useEffect(() => {
    getAreas()
    if (defaultValue) {
      if (!single) {
        setValue(getIdArray(defaultValue))
      } else {
        setValue(defaultValue)
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event, newValue) => {
    // setLocalValue(newValue)
    if (!single) {
      setValue(getIdArray(newValue))
    } else {
      setValue(newValue)
    }
  }

  const setDefaultValue = () => {
    if (defaultValue) {
      return defaultValue
    }
    if (single) {
      return null
    }
    return []
  }

  return (
    <Autocomplete
      className={className}
      getOptionSelected={(option, value) => option.id === value.id}
      onChange={handleChange}
      multiple={!single}
      defaultValue={setDefaultValue()}
      filterSelectedOptions
      options={areasOfLaw}
      autoHighlight
      fullWidth
      getOptionLabel={(area) => area.name}
      renderOption={(area) => (
        <React.Fragment>
          {area.name}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Areas of law'
          variant='outlined'
          fullWidth
          required
          error={error}
          helperText={helperText}
          name='areas_of_law'
          InputLabelProps={InputLabelProps}
          color='secondary'
          placeholder={placeholder || 'Select areas of law...'}
        />
      )}
    />
  )
}

export default AreasOfLawInput
